import { render, staticRenderFns } from "./RecruiterReport.vue?vue&type=template&id=3f2b7dd0&scoped=true&"
import script from "./RecruiterReport.vue?vue&type=script&lang=js&"
export * from "./RecruiterReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b7dd0",
  null
  
)

export default component.exports